// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	UploadButton: 'upload-button',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
